import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API, DATE } from '@const'
import * as utils from '@utils'
import { Button, Tooltip  } from '@material-ui/core'
import ComponentDialog from '@dialogs/component-dialog'
import GameRoundResultPage from '../pages/game-round-result-page'
import { SaveAlt } from '@material-ui/icons'
import { Table } from 'antd'

class PlayerBetReportTable extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'PlayerBetReportTable')
        }
        this.handleTableChange = this.handleTableChange.bind(this)
    }

    state = {
        currency: '',
        list: [],
        dataLength: 0,
        loading: false,
        currentPage: 1,
        pageLimit: 10,
        total: 0,
        pageSizeOptions: ['10','30','50','100']
    }

    columns = [
        {
            title: utils.t('pf_sub_pf_id', 'PlayerBetReportTable'),
            dataIndex: 'pf_sub_pf_id',
            align: 'center',
            render: (text) => {
                return text ? utils.GeneratePfSubPfName(text) : ''
            },
            
        },
        {
            title: utils.t('pf_account', 'PlayerBetReportTable'),
            dataIndex: 'pf_account',
            align: 'center',
        },
        {
            title: utils.t('origin_account', 'PlayerBetReportTable'),
            dataIndex: 'origin_account',
            align: 'center',
        },
        {
            title: utils.t('bet_amount', 'PlayerBetReportTable'),
            dataIndex: 'bet_amount',
            align: 'center',
            render: (text, record) => {
                const display = utils.currencyFormatter(text, 0)
                return (
                    <div className="textRight">
                        <Button
                            className={this.props.classes.linkButton}
                            onClick={() =>
                                this.compDialog.OpenDialog(
                                    this.t('GameRoundResultPage'),
                                    <GameRoundResultPage
                                        compDialogArgs={{
                                            dateUnit: this.props?.compDialogArgs?.dateUnit || 'day',
                                            searchType: 'date',
                                            displayGameTypeCode: this.state.displayGameTypeCode,
                                            gameCode: this.state.gameCode,
                                            startDate: this.state.startDate,
                                            endDate: this.state.endDate,
                                            pfAccount: record['pf_account'],
                                            pfId: record['pf_id'],
                                            pfSubPfId: record['pf_sub_pf_id'],
                                        }}></GameRoundResultPage>
                                )
                            }>
                            {display}
                        </Button>
                    </div>
                ) 
            },
            sorter: true
        },
        {
            title: utils.t('bet', 'PlayerBetReportTable'),
            dataIndex: 'bet',
            align: 'center',
            render: (text) => {
                const display = utils.currencyTrans(text, this.state.currency)
                return display
            },
            sorter: true
        },
        {
            title: utils.t('bet_valid', 'PlayerBetReportTable'),
            dataIndex: 'bet_valid',
            align: 'center',
            render: (text) => {
                const display = utils.currencyTrans(text, this.state.currency)
                return display
            },
            sorter: true
        },
        {
            title: utils.t('profit', 'PlayerBetReportTable'),
            dataIndex: 'profit',
            align: 'center',
            render: (text) => {
                const display = utils.currencyTrans(text, this.state.currency)
                const fontColor = text < 0 ? 'red' : ''
                return <div style={{ color: fontColor }}>{display}</div>
            },
            sorter: true
        },
        {
            title: utils.t('tax', 'PlayerBetReportTable'),
            dataIndex: 'tax',
            align: 'center',
            render: (text) => {
                const display = utils.currencyTrans(text, this.state.currency)
                return display
            },
            sorter: true
        },
    ]

    componentDidMount() {
        const currency = this.props.compDialogArgs ? utils.getPfCurrency(this.props.compDialogArgs.pfId) : ''
        this.props.compDialogArgs && this.setState({
            ...this.props.compDialogArgs,
            currency
        }, this.handleSearch)
    }

    queryData() {
        this.setState({ loading: true })
        const dateUnit = this.props?.compDialogArgs?.dateUnit || 'day'
        /** 開啟此頁面並攜帶額外apiUrl */
        const apiUrl = this.props?.compDialogArgs?.apiUrl || API.BET_RECORD_SUM_LIST_BY_PF_ACCOUNT

        const queryParams = {
            lang: utils.getCurrentLang(),
            start_date: utils.datetimeToUnix_startOf(this.state.startDate, dateUnit),
            end_date: utils.datetimeToUnix_endOf(this.state.endDate, dateUnit),
            pf_id: this.state.pfId,
            pf_sub_pf_id: this.state.pfSubPfId !== 'all' ? this.state.pfSubPfId : '',
            display_game_type_code_id: this.state.displayGameTypeCode !== 'all' ? this.state.displayGameTypeCode : '',
            game_code: this.state.gameCode !== 'all' ? this.state.gameCode : '',
            timezone: DATE.CLIENT_UTC_OFFSET,
            page: this.state.currentPage,
            limit: this.state.pageLimit
        }
        
        /** 對帳報表父層查詢 */
        if (this.props.compDialogArgs.proprietor_id) {
            queryParams.proprietor_id = this.props.compDialogArgs.proprietor_id
        }
        /** 動態時區 */
        if (this.props.compDialogArgs.timeZone) {
            queryParams.timezone = this.props.compDialogArgs.timeZone
        }


        if (this.state.sort_field !== '' && this.state.sort_order !== '') {
            const sortParams = {
                "ascend": 'ASC',
                "descend": 'DESC'
            }
            queryParams.sort_field = this.state.sort_field
            queryParams.sort_order = sortParams[this.state.sort_order]
        }

        utils.apiRequest(
            'get',
            apiUrl,
            queryParams,
            ({data, page}) => {
                const list = data?.bet_record_list || data
                list.forEach((item, index) => {
                    item.id = index + ((this.state.currentPage - 1) * this.state.pageLimit)
                })
                this.setState({
                    list,
                    dataLength: page.count,
                    loading: false
                })
            },
            (_err) => {
                this.setState({
                    list: [],
                    dataLength: 0,
                    loading: false
                })
            },
            true
        )
    }
    /** submit */
    handleSearch() {
        this.setState({
            currentPage: 1
        }, () => {
            this.queryData()
            utils.goTop()
        })
        
    }
    /** change page / limit */
    handlePageChange(page, limit) {
        this.setState({
            currentPage: page,
            pageLimit: limit
        }, () => {
            this.queryData()
            utils.goTop()
        })
    }

    handleTableChange(pagination, _filters, sorter) {
        const sort = (field, order) => {
            this.setState({
                sort_field: field,
                sort_order: order,
                pageLimit: pagination.pageSize
            })
        }
        sorter.order ? sort(sorter.field, sorter.order) : sort('', '')
    }

    handleExport() {
        const dateUnit = this.props?.compDialogArgs?.dateUnit || 'day'
        const params = {
            start_date: utils.datetimeToUnix_startOf(this.state.startDate, dateUnit),
            end_date: utils.datetimeToUnix_endOf(this.state.endDate, dateUnit),
            game_code: this.state.gameCode !== 'all' ? this.state.gameCode : '',
            pf_id: this.state.pfId,
            pf_sub_pf_id: this.state.pfSubPfId !== 'all' ? this.state.pfSubPfId : '',
            type: this.props?.compDialogArgs.exportType,
            lang: utils.getCurrentLang(),
        }

        if (this.state.sort_field !== '' && this.state.sort_order !== '') {
            const sortParams = {
                "ascend": 'ASC',
                "descend": 'DESC'
            }
            params.sort_field = this.state.sort_field
            params.sort_order = sortParams[this.state.sort_order]
        }

       
        utils.apiRequest(
            'get',
            API.DOWNLOAD_RECORD_URL,
            params,
            (response) => {
                const fullUrl = window.location.href;
                const url = new URL(fullUrl);
                const protocol = url.protocol;
                const hostname = url.hostname; 
                const port = url.port; 
                const baseUrl = `${protocol}//${hostname}${port ? `:${port}` : ''}`;
                if (process.env.REACT_APP_ENVIROMENT !== 'local') {
                    window.open(baseUrl + process.env.REACT_APP_SERVER_PATH + response, '_blank');
                } else {
                    window.open(baseUrl + response, '_blank');
                }
            }
        )
    }

    render() {
        return (
            <React.Fragment>
                <div 
                    onClick={() => {
                        this.handleExport()
                    }} 
                    className={this.props.classes.exportExcel}
                >
                    <Tooltip title={this.t('export')}>
                        <SaveAlt />
                    </Tooltip>
                </div>
                <Table
                    className="play-bet-report-table"
                    size="small"
                    loading={this.state.loading}
                    columns={this.columns}
                    dataSource={this.state.list}
                    bordered
                    rowKey="id"
                    locale={{
                        emptyText: utils.t('noRecordsToDisplay', 'Table')
                    }}
                    pagination={{
                        current: this.state.currentPage,
                        pageSize: this.state.pageLimit,
                        total: this.state.dataLength,
                        showTotal: () => ``,
                        onChange: (nextPage, currentPageSize) => {
                            this.handlePageChange(nextPage, currentPageSize)
                        },
                        onShowSizeChange: (currentPage, nextSize) => {
                            this.handlePageChange(1, nextSize)
                        },
                        showSizeChanger: true, // 允许改变每页显示的条数
                        pageSizeOptions: this.state.pageSizeOptions, // 每页显示的条数选项
                    }}
                    onChange={this.handleTableChange} // 排序 篩選 資料變更 都會觸發這裡 目前用來 call 排序 api
                />
                <ComponentDialog onRef={(ref) => (this.compDialog = ref)}></ComponentDialog>
            </React.Fragment> 
        )  
    }
}

const styles = (_theme) => {
    return {
        linkButton: {
            background: 'none!important',
            border: 'none',
            padding: '0!important',
            color: '#1890ff',
            textDecoration: 'none',
            cursor: 'pointer',
            userSelect: 'text',
            outline: 'none !important',
            '& span': {
                justifyContent: 'flex-end',
            }
        },
        exportExcel: {
            position: 'absolute',
            right: '25px',
            top: '12px',
            color: 'white',
            cursor: 'pointer',
        }
    }
}

PlayerBetReportTable.propTypes = {
    classes: PropTypes.object.isRequired,
    auth: PropTypes.object,
    dataService: PropTypes.object,
    compDialogArgs: PropTypes.object,
}

export default hoc(styles)(PlayerBetReportTable)
